import { useEffect, useState } from "react";
import { Container } from '@mui/material';
import { NavLink, useParams } from "react-router-dom";

import { IContainer } from "../../../types/container";

import { useUserContext } from "../../../contexts/userContext";
import { ContainerService } from "../../../services/containerService";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import ContainerDetailsForm from "../../forms/containerDetailsForm";
import Spinner from "../../spinner";
import { Icons } from "../../icons";

const ContainerEdit = () => {
	const userContext = useUserContext();
	let { id } = useParams();
	const [container, setContainer] = useState<IContainer>();
	const [isLoadingContainer, setIsLoadingContainer] = useState(true);

	useEffect(() => {
		getContainer();
	}, [])

	const getContainer = async () => {
		if (id) {
			ContainerService.getContainer(id)
				.then((response) => {
					console.log('ContainerService.getContainer: SUCCESS', response);
					setContainer(ContainerService.mapContainer(response.data));
				})
				.catch((error) => {
					console.log('ContainerService.getContainer: ERROR', error);
				})
				.finally(() => {
					setIsLoadingContainer(false);
				});
		}
	}

	return (
		<div className="hwi-container-edit">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageCustomers}>
					<>
						<Spinner dependency={isLoadingContainer} text="Loading container...">
							<section className="management-page-header">
								<div className="title">
									<NavLink to="/container">
										<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
									</NavLink>
									{container?.name}
								</div>
							</section>
							<Spinner dependency={isLoadingContainer} text="Loading container...">
								{container &&
									<ContainerDetailsForm action="edit" id={id!} details={container!} reloadData={getContainer}></ContainerDetailsForm>
								}
								
							</Spinner>
						</Spinner>
					</>
				</PermissionGate>
				{/* <Json data={container}></Json> */}
			</Container>
		</div>
	);
};

export default ContainerEdit;
